import { Identifiable } from '@/model/Identifiable';

export const getCategoryTagName = (categoryTagId: string, categoryTags: Identifiable[]): string =>
  categoryTags?.find((categoryTag) => categoryTag.id === categoryTagId)?.name;
